import t from "../../app/i18n";

export enum DashboardNoticeType {
  INFO = "INFO",
  WARNING = "WARNING",
  ERROR = "ERROR",
}

export enum DashboardNoticePosition {
  VEHICLE_CALC = "VEHICLE_CALC",
  REALTY_CALC = "REALTY_CALC",
  TRAVEL_CALC = "TRAVEL_CALC",
}

export enum DashboardContactType {
  INTERNAL = "INTERNAL",
  EXTERNAL = "EXTERNAL",
}

export const dashboardNoticeTypeTMap = new Map<DashboardNoticeType, string>(
  Object.values(DashboardNoticeType).map((type) => [type, t(`dashboard.notices.enums.type.${type}`)]),
);

export const dashboardNoticePositionTMap = new Map<DashboardNoticePosition, string>(
  Object.values(DashboardNoticePosition).map((position) => [
    position,
    t(`dashboard.notices.enums.position.${position}`),
  ]),
);

export enum DashboardWidgetType {
  AGENT_EDUCATIONS = "AGENT_EDUCATIONS",
  AGENT_EXPERTISES = "AGENT_EXPERTISES",
  COMMISSIONS = "COMMISSIONS",
  CONTACTS = "CONTACTS",
  CONTRACT_STATISTICS = "CONTRACT_STATISTICS",
  CONTRACT_STATUSES = "CONTRACT_STATUSES",
  EVENTS = "EVENTS",
  GOALS = "GOALS",
  LOGO = "LOGO",
  MLM_STRUCTURE = "MLM_STRUCTURE",
  NOTICES = "NOTICES",
  PERSONAL_DATES = "PERSONAL_DATES",
  PERSONAL_DATES_EXTENDED = "PERSONAL_DATES_EXTENDED",
  PORTFOLIO = "PORTFOLIO",
  STATISTICS = "STATISTICS",
  STATISTICS_EXTENDED = "STATISTICS_EXTENDED",
}

export enum DashboardCommissionsPeriod {
  TOTAL = "TOTAL",
  CURRENT_YEAR = "CURRENT_YEAR",
  LAST_YEAR = "LAST_YEAR",
  AVERAGE = "AVERAGE",
}

export enum DashboardGoalType {
  BROKER_POINTS = "BROKER_POINTS",
  BROKER_ALL_TRAINEES = "BROKER_ALL_TRAINEES",
  BROKER_CLIENTS = "BROKER_CLIENTS",
  BROKER_AGENTS = "BROKER_AGENTS",
  BROKER_COMMISSIONS = "BROKER_COMMISSIONS",
  BROKER_LEVEL = "BROKER_LEVEL",
  BROKER_RANK = "BROKER_RANK",
  TIPPER_POINTS = "TIPPER_POINTS",
  TIPPER_DIRECT_TRAINEES = "TIPPER_DIRECT_TRAINEES",
  TIPPER_COMMISSIONS = "TIPPER_COMMISSIONS",
  TIPPER_BASIC_ACADEMY = "TIPPER_BASIC_ACADEMY",
  TIPPER_STATUS = "TIPPER_STATUS",
  TIPPER_ALL_TRAINEES = "TIPPER_ALL_TRAINEES",
}

export enum DATA_UNIT {
  CONTRACT_COUNT = "CONTRACT_COUNT",
  AMOUNT_SUM = "AMOUNT_SUM",
}

export enum DashboardCommissionsReport {
  POINTS = "POINTS",
  AMOUNTS = "AMOUNTS",
}
